// Login admin: email + password. DECISION-PENDING(Q16): MFA TOTP (aplikasi autentikator) nonaktif sementara
// di backend; `login` langsung menerbitkan cookie sesi.
import { useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';

import { Alert, Button, Field } from '../components/ui';
import { api, errorMessage } from '../lib/api';

export function LoginPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    void (async () => {
      try {
        await api('login', { body: { email, password } });
        await queryClient.invalidateQueries({ queryKey: ['session'] });
        void navigate('/', { replace: true });
      } catch (e) {
        setError(errorMessage(e));
      } finally {
        setBusy(false);
      }
    })();
  };

  return (
    <main className="relative flex min-h-dvh items-center justify-center bg-slate-900 p-4 overflow-hidden">
      {/* Background glow effects */}
      <div className="absolute top-1/4 -left-20 size-96 rounded-full bg-[#3851F0]/20 blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 -right-20 size-96 rounded-full bg-[#E757F1]/15 blur-3xl pointer-events-none" />

      <div className="relative w-full max-w-md space-y-6 rounded-3xl bg-white p-8 sm:p-10 shadow-2xl ring-1 ring-slate-200/80">
        {/* Brand Header */}
        <div className="space-y-2 text-center">
          <div className="inline-flex size-14 items-center justify-center rounded-2xl bg-gradient-to-tr from-[#3851F0] to-[#2B65EE] shadow-lg shadow-blue-500/30">
            <span className="text-2xl font-black text-white">F+</span>
          </div>
          <div>
            <h1 className="text-2xl font-black tracking-tight text-slate-900">Masuk CMS Fola+</h1>
            <p className="text-xs text-slate-500 font-medium mt-1">
              Portal Administrasi & Operasional Member-Get-Member
            </p>
          </div>
        </div>

        <form className="space-y-4 pt-2" onSubmit={submit}>
          <Field
            label="Email"
            type="email"
            placeholder="admin@folaplus.com"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Field
            label="Password"
            type="password"
            placeholder="••••••••"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error ? <Alert tone="error">{error}</Alert> : null}
          <Button type="submit" className="w-full justify-center py-2.5 text-sm" loading={busy}>
            Masuk
          </Button>
        </form>

        <div className="border-t border-slate-100 pt-4 text-center">
          <p className="text-[11px] text-slate-400 font-medium">
            Setiap aktivitas admin tercatat di audit log.
          </p>
        </div>
      </div>
    </main>
  );
}
